import type { ExportCell, ExportTable } from './export.types';

export const CSV_BOM = '﻿';
export const CSV_MIME_TYPE = 'text/csv;charset=utf-8';

const FORMULA_START = /^[=+\-@\t\r]/;
const NEEDS_QUOTES = /[",\r\n]/;

const neutraliseFormula = (value: string): string => (FORMULA_START.test(value) ? `'${value}` : value);

const escapeCell = (cell: ExportCell): string => {
  const text = typeof cell === 'string' ? neutraliseFormula(cell) : String(cell);
  return NEEDS_QUOTES.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** CSV text (UTF-8 BOM, CRLF lines, RFC 4180 quoting) of a table. */
export const buildCsv = ({ headers, rows }: ExportTable): string =>
  CSV_BOM + [headers, ...rows].map(row => row.map(escapeCell).join(',')).join('\r\n');
